<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    import { on, off } from 'view-design/src/utils/dom';
    import { setMatchMedia } from 'view-design/src/utils/assist';
    import { mapMutations } from 'vuex';
    setMatchMedia();


    export default {
        name: 'app',
        methods: {
            ...mapMutations('system/layout', [
                'setDevice'
            ]),
            handleWindowResize () {
                this.handleMatchMedia();
            },
            handleMatchMedia () {
                const matchMedia = window.matchMedia;

                if (matchMedia('(max-width: 600px)').matches) {
                    this.setDevice('Mobile');
                } else if (matchMedia('(max-width: 992px)').matches) {
                    this.setDevice('Tablet');
                } else {
                    this.setDevice('Desktop');
                }
              this.$bus.$emit('resize',{h:$(document).outerHeight(),w:$(document).outerWidth()});
            }
        },
        mounted () {
            on(window, 'resize', this.handleWindowResize);
            this.handleMatchMedia();
        },
        beforeDestroy () {
            off(window, 'resize', this.handleWindowResize);
        }
    }


</script>

<style>
 .main-content{
   width:1200px;
   margin: 0px auto;
 }
 .imgZoom{-moz-transition:all .8s ease 0s;-ms-transition:all .8s ease 0s;-o-transition:all .8s ease 0s;/* -webkit-transition:all .8s ease 0s; */transition:all .8s ease 0s;}
 .imgZoom { overflow:hidden; -webkit-transform:rotate(0); transform:rotate(0); }
 .imgZoom img{-moz-transition:all .8s ease 0s;-ms-transition:all .8s ease 0s;-o-transition:all .8s ease 0s;/* -webkit-transition:all .8s ease 0s; */transition:all .8s ease 0s;}
 .imgZoom:hover img{ -moz-transform:scale(1.1,1.1); -ms-transform:scale(1.1,1.1); -o-transform:scale(1.1,1.1); -webkit-transform:scale(1.1,1.1); transform:scale(1.1,1.1);}
  .not-text{
    background:#ccc -webkit-linear-gradient(left,#ccc,#7d7b7b 50%,#474646 90%,#ccc) no-repeat 0 0;
    background-size:20% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    font-weight: bold;
    text-decoration: underline;
    font-size:14px;color: #ccc;
    -webkit-animation: slideShine 2s linear infinite;animation: slideShine 2s linear infinite;
  }
 @-webkit-keyframes slideShine {
   0% {
     background-position: 0 0;
   }
   100% {
     background-position: 100% 100%;
   }
 }
 @keyframes slideShine {
   0% {background-position: 0 0; }
   100% {background-position: 100% 100%; }
 }

.total-page{padding: 40px 0;text-align: center;}
 .transYT50 { transform: translateY(50px); -webkit-transform: translateY(50px); opacity: 0; visibility: hidden; transition: transform 1000ms,opacity .5s cubic-bezier(0.445, 0.145, 0.355, 1); -webkit-transition: transform 600ms,opacity .5s cubic-bezier(0.445, 0.145, 0.355, 1); transition-timing-function: ease-out; -webkit-transition-timing-function: ease-out; }
 .transYT50.trans-show{opacity: 1;visibility: visible;transform: translateY(0px);-webkit-transform: translateY(0px);}
 .dly_1 { transition-delay: 100ms; -webkit-transition-delay: 100ms; }
 .dly_2 { transition-delay: 200ms; -webkit-transition-delay: 200ms; }
 .dly_3 { transition-delay: 300ms; -webkit-transition-delay: 300ms; }
 .dly_4 { transition-delay: 400ms; -webkit-transition-delay: 400ms; }
 .dly_5 { transition-delay: 500ms; -webkit-transition-delay: 500ms; }
 .dly_6 { transition-delay: 600ms; -webkit-transition-delay: 600ms; }
 .dly_7 { transition-delay: 700ms; -webkit-transition-delay: 700ms; }
 .dly_8 { transition-delay: 800ms; -webkit-transition-delay: 800ms; }
 .dly_9 { transition-delay: 900ms; -webkit-transition-delay: 900ms; }
 .dly_10 { transition-delay: 1000ms; -webkit-transition-delay: 1000ms; }
 .dly_11 { transition-delay: 1100ms; -webkit-transition-delay: 1100ms; }
</style>



// WEBPACK FOOTER //
// src/App.vue